// extracted by mini-css-extract-plugin
export var bottomRightDock = "_4x-0";